module.exports = __webpack_public_path__ + "assets/img/vtuber-left1.b001ab1e.png";